module.exports = __webpack_public_path__ + "static/media/pdf-svgrepo-com.c919d52c.svg";